"use client";

import React, { useState } from "react";
import { Sparkles, Play, Check, BrainCircuit } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger, DialogFooter } from "@/components/ui/dialog";
const nodes = [{
  id: 0,
  x: 15,
  y: 25,
  r: 4,
  delay: "0s"
}, {
  id: 1,
  x: 45,
  y: 15,
  r: 6,
  delay: "1s"
}, {
  id: 2,
  x: 85,
  y: 35,
  r: 3,
  delay: "0.5s"
}, {
  id: 3,
  x: 25,
  y: 75,
  r: 5,
  delay: "2s"
}, {
  id: 4,
  x: 55,
  y: 85,
  r: 4,
  delay: "1.5s"
}, {
  id: 5,
  x: 90,
  y: 65,
  r: 5,
  delay: "0.2s"
}, {
  id: 6,
  x: 50,
  y: 50,
  r: 8,
  delay: "0.8s"
}, {
  id: 7,
  x: 10,
  y: 55,
  r: 3,
  delay: "2.5s"
}, {
  id: 8,
  x: 75,
  y: 15,
  r: 4,
  delay: "1.2s"
}];
const connections = [[0, 1], [1, 2], [0, 3], [3, 4], [4, 5], [1, 6], [3, 6], [4, 6], [2, 8], [6, 8], [0, 7], [7, 3], [2, 5], [6, 2]];
const genres = ["Baumfällung", "Baumpflege", "Wurzelentfernung", "Totholzentfernung", "Gebäudefreischnitt", "Baumhausbau", "Baubegleitung", "Sturmschaden"];
export default function PersonalizedForYou() {
  const [selectedGenres, setSelectedGenres] = useState<number[]>([]);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [quizComplete, setQuizComplete] = useState(false);
  const toggleGenre = (index: number) => {
    setSelectedGenres(prev => prev.includes(index) ? prev.filter(i => i !== index) : [...prev, index]);
  };
  const handleQuizSubmit = () => {
    setIsSubmitting(true);
    setTimeout(() => {
      setIsSubmitting(false);
      setQuizComplete(true);
    }, 1500);
  };
  return;
}